import { render, staticRenderFns } from "./TimeslotDetailsModal.vue?vue&type=template&id=ed709aae&"
import script from "./TimeslotDetailsModal.vue?vue&type=script&lang=js&"
export * from "./TimeslotDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports